import React, { useEffect, useState } from "react";
import { API } from "../../api/axios";
import "./contactSupportPopup.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactSupportPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await API.post("/support-requests", formData);
      toast.success(response.data.message || "Your support request has been submitted.");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Unable to submit support request. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="popup-overlay1"
      onMouseDown={(event) => event.target === event.currentTarget && onClose()}
    >
      <div className="popup-content" role="dialog" aria-modal="true" aria-labelledby="contact-support-title">
        <button className="close-button" type="button" onClick={onClose} aria-label="Close contact form">
          &times;
        </button>
        <h2 id="contact-support-title">Contact Us</h2>
        <p className="contact-intro">Have a question? Send us a message and our team will get back to you.</p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-form-row">
            <label>
              First Name *
              <input name="firstName" value={formData.firstName} onChange={handleChange} required />
            </label>
            <label>
              Last Name *
              <input name="lastName" value={formData.lastName} onChange={handleChange} required />
            </label>
          </div>
          <div className="contact-form-row">
            <label>
              Email Address *
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </label>
            <label>
              Phone Number
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
            </label>
          </div>
          <label>
            Subject *
            <select name="subject" value={formData.subject} onChange={handleChange} required>
              <option value="">Select a subject</option>
              <option value="Billing">Billing</option>
              <option value="Technical">Technical</option>
              <option value="General">General</option>
              <option value="Other">Other</option>
            </select>
          </label>
          <label>
            Message *
            <textarea name="message" rows="4" value={formData.message} onChange={handleChange} required />
          </label>
          <button className="contact-submit" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
};

export default ContactSupportPopup;
